// extracted by mini-css-extract-plugin
module.exports = {"benefitsSection":"benefits-section_benefitsSection__UYMwI"};